import { computed } from "vue";

<template>
  <i class="iconfont" :class="name" :style="getWrapStyle"></i>
</template>

<script setup lang="ts">
  import { CSSProperties, computed } from 'vue';
  import { propTypes } from '@mcex/utils';
  import { isString } from '@mcex/utils';

  const props = defineProps({
    name: {
      type: String,
      default: '',
    },
    // icon color
    color: propTypes.string,
    // icon size
    size: {
      type: [String, Number] as PropType<string | number>,
      default: 16,
    },
  });
  const getWrapStyle = computed((): CSSProperties => {
    const { size, color } = props;
    let fs = size;
    if (isString(size)) {
      fs = parseInt(size, 10);
    }

    return {
      fontSize: `${fs}px`,
      color: color,
    };
  });
</script>
